import React, { useEffect, useMemo, useState } from "react";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { setFilteredNavData } from "../../../../../store/slices/LeadreportfilteredSlice";
import { useDispatch } from "react-redux";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import CommaConvert from "../../../../../utils/CommaConvert";

const HistoricaltableL1 = ({ historicalDownload, selectedStatus }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const currency = useCurrencySymbol();
  const USAComma = CommaConvert();
  const [nonResponsive, setNonResponsive] = useState([]);

  useEffect(() => {
    setNonResponsive(selectedStatus)
  }, [selectedStatus])

  const [filteredLeadReports, setFilteredLeadReports] = useState([]);

  useEffect(() => {
    setFilteredLeadReports(historicalDownload);
  }, [historicalDownload]);

  useEffect(() => {
    if (historicalDownload.length > 0) {
      setFilteredLeadReports(historicalDownload);
    }
  }, [historicalDownload]);

  const handleTdClick = (year, status = null) => {
    const filteredLeads = filteredLeadReports.filter((lead) => {
      let leadYear;

      try {
        const parsedDate = new Date(lead.LeadDate);
        leadYear = parsedDate.getFullYear(); // Extract year
      } catch (error) {
        console.error("Invalid Date Format:", lead.LeadDate);
        return false; // Skip invalid date formats
      }

      if (status) {
        return leadYear === year && lead.Status === status;
      } else {
        return leadYear === year;
      }
    });

    // Store in state
    dispatch(setFilteredNavData(filteredLeads));

    navigate(`/dashboard/lead-report`);
  };

  const { groupedData, totalLeads, statusWiseTotals } = useMemo(() => {
    const twoYearsAgo = new Date();
    twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);
    const grouped = filteredLeadReports.reduce((acc, report) => {
      const year = new Date(report.LeadDate).getFullYear();
      // const status = report.Status;
      const status = report.Status.charAt(0).toUpperCase() + report.Status.slice(1).toLowerCase();
      const quotedValue = report.QuotedValue || 0;
      // const leadDate = new Date(report.LeadDate);

      if (!acc[year]) {
        acc[year] = {
          year,
          totalAmount: 0,
          totalLeads: 0,
          statusWise: {},
        };
      }

      if (!acc[year].statusWise[status]) {
        acc[year].statusWise[status] = { count: 0, totalQuotedValue: 0 };
      }

      // Accumulate data for given status
      acc[year].totalAmount += quotedValue;
      acc[year].totalLeads += 1;
      acc[year].statusWise[status].count += 1;
      acc[year].statusWise[status].totalQuotedValue += quotedValue;

      return acc;
    }, {});

    // Add "Non Responsive" Status with count and totalQuotedValue per year
    Object.keys(grouped).forEach((year) => {
      let nonResponsiveCount = 0;
      let nonResponsiveTotalQuotedValue = 0;

      // Loop through filtered leads and count "Pending" ones older than 2 years
      filteredLeadReports.forEach((report) => {
        const reportYear = new Date(report.LeadDate).getFullYear();
        if (
          reportYear === Number(year) &&
          report.Status === "Pending" &&
          new Date(report.LeadDate) < twoYearsAgo
        ) {
          nonResponsiveCount += 1;
          nonResponsiveTotalQuotedValue += report.QuotedValue || 0;
        }
      });

      // Add to statusWise object
      grouped[year].statusWise["Non Responsive"] = {
        count: nonResponsiveCount,
        totalQuotedValue: nonResponsiveTotalQuotedValue,
      };
    });

    // Compute grand totals
    const totalLeads = filteredLeadReports.length;
    const totalAmount = filteredLeadReports.reduce(
      (sum, report) => sum + (report.QuotedValue || 0),
      0
    );
    // Transform data to array
    // const groupedData = Object.values(grouped);
    const groupedData = Object.values(grouped).map((yearData) => {
      // Initialize an empty object to hold the filtered statusWise data
      let filteredStatusWise = {};

      // Check if nonResponsive is set and corresponds to a key in statusWise
      if (nonResponsive && yearData.statusWise[nonResponsive]) {
        // Include only the specified status in the filteredStatusWise object
        filteredStatusWise[nonResponsive] = yearData.statusWise[nonResponsive];
      } else {
        // If nonResponsive is not set or doesn't match any key, include all statuses
        filteredStatusWise = { ...yearData.statusWise };
      }

      // Return the updated yearData with the filtered statusWise object
      return { ...yearData, statusWise: filteredStatusWise };
    });





    // Extract status-wise totals for all years
    const statusWiseTotals = groupedData.reduce((acc, { year, statusWise }) => {
      Object.entries(statusWise).forEach(([status, { totalQuotedValue }]) => {
        if (!acc[status]) acc[status] = {};
        acc[status][year] = totalQuotedValue;
      });
      return acc;
    }, {});

    return { groupedData, totalLeads, totalAmount, statusWiseTotals };
  }, [filteredLeadReports, nonResponsive]);

  const [groupedArray, setGroupedArray] = useState([]);
  useEffect(() => {
    setGroupedArray(Object.values(groupedData));
  }, [groupedData]);



  const [, setRefreshTable] = useState(false);

  const numericSort = (order) => {
    order === "az"
      ? groupedArray.sort((a, b) => Number(a.totalLeads) - Number(b.totalLeads))
      : groupedArray.sort(
        (a, b) => Number(b.totalLeads) - Number(a.totalLeads)
      );

    setRefreshTable((prev) => !prev);
  };

  const WonnumericSort = (order) => {
    groupedArray.sort((a, b) => {
      const valA = Number(a.statusWise["Won"]?.totalQuotedValue) || 0;
      const valB = Number(b.statusWise["Won"]?.totalQuotedValue) || 0;

      return order === "az" ? valA - valB : valB - valA;
    });

    setRefreshTable((prev) => !prev);
  };

  const WonRecurringSort = (order) => {
    groupedArray.sort((a, b) => {
      const valA = Number(a.statusWise["Won Recurring"]?.totalQuotedValue) || 0;
      const valB = Number(b.statusWise["Won Recurring"]?.totalQuotedValue) || 0;

      return order === "az" ? valA - valB : valB - valA;
    });

    setRefreshTable((prev) => !prev);
  };

  const PendingSort = (order) => {
    groupedArray.sort((a, b) => {
      const valA = Number(a.statusWise["Pending"]?.totalQuotedValue) || 0;
      const valB = Number(b.statusWise["Pending"]?.totalQuotedValue) || 0;

      return order === "az" ? valA - valB : valB - valA;
    });

    setRefreshTable((prev) => !prev);
  };


  const LostSort = (order) => {
    groupedArray.sort((a, b) => {
      const valA = Number(a.statusWise["Lost"]?.totalQuotedValue) || 0;
      const valB = Number(b.statusWise["Lost"]?.totalQuotedValue) || 0;

      return order === "az" ? valA - valB : valB - valA;
    });

    setRefreshTable((prev) => !prev);
  };

  const NonResponsiveSort = (order) => {
    order === "az"
      ? groupedArray.sort(
        (a, b) =>
          Number(a.statusWise["Non Responsive"]?.totalQuotedValue) -
          Number(b.statusWise["Non Responsive"]?.totalQuotedValue)
      )
      : groupedArray.sort(
        (a, b) =>
          Number(b.statusWise["Non Responsive"]?.totalQuotedValue) -
          Number(a.statusWise["Non Responsive"]?.totalQuotedValue)
      );

    setRefreshTable((prev) => !prev);
  };

  return (
    <div className="w-full rounded-lg border border-gray-200 bg-white p-2">
      <div className="max-h-[18rem] overflow-auto">
        <table className="w-full divide-y divide-gray-200 border border-gray-200 text-xs text-gray-800">
          <thead className="sticky top-0 z-10 bg-gray-50 text-xs font-semibold uppercase tracking-wide text-gray-600">
            <tr>
              {/*<th className="px-4 py-3 text-center border text-sm font-medium  tracking-wider">#</th>*/}
              <th className="border-b border-gray-200 px-3 py-2 text-left">
                Year
              </th>
              <th className="border-b border-gray-200 px-3 py-2 text-center">
                <div className="flex items-center justify-center">
                  Total Leads
                  <div className="flex flex-col gap-y-1 ml-3">
                    <div
                      className="cursor-pointer"
                      onClick={() => numericSort("za")}
                    >
                      <ArrowDropUp sx={{ fontSize: 22, color: "#6b7280" }} />
                    </div>

                    <div
                      className="cursor-pointer -mt-2"
                      onClick={() => numericSort("az")}
                    >
                      <ArrowDropDown sx={{ fontSize: 22, color: "#6b7280" }} />
                    </div>
                  </div>
                </div>
              </th>
              <th className="border-b border-gray-200 px-3 py-2 text-center">
                <div className="flex items-center justify-center">
                  Won ({currency})
                  <div className="flex flex-col gap-y-1 ml-3">
                    <div
                      className="cursor-pointer"
                      onClick={() => WonnumericSort("za")}
                    >
                      <ArrowDropUp sx={{ fontSize: 22, color: "#6b7280" }} />
                    </div>

                    <div
                      className="cursor-pointer -mt-2"
                      onClick={() => WonnumericSort("az")}
                    >
                      <ArrowDropDown sx={{ fontSize: 22, color: "#6b7280" }} />
                    </div>
                  </div>
                </div>
              </th>
              <th className="border-b border-gray-200 px-3 py-2 text-center">
                <div className="flex items-center justify-center">
                  Won Recurring ({currency})
                  <div className="flex flex-col gap-y-1 ml-3">
                    <div
                      className="cursor-pointer"
                      onClick={() => WonRecurringSort("za")}
                    >
                      <ArrowDropUp sx={{ fontSize: 22, color: "#6b7280" }} />
                    </div>

                    <div
                      className="cursor-pointer -mt-2"
                      onClick={() => WonRecurringSort("az")}
                    >
                      <ArrowDropDown sx={{ fontSize: 22, color: "#6b7280" }} />
                    </div>
                  </div>
                </div>
              </th>
              <th className="border-b border-gray-200 px-3 py-2 text-center">
                <div className="flex items-center justify-center">
                  Pending ({currency})
                  <div className="flex flex-col gap-y-1 ml-3">
                    <div
                      className="cursor-pointer"
                      onClick={() => PendingSort("za")}
                    >
                      <ArrowDropUp sx={{ fontSize: 22, color: "#6b7280" }} />
                    </div>

                    <div
                      className="cursor-pointer -mt-2"
                      onClick={() => PendingSort("az")}
                    >
                      <ArrowDropDown sx={{ fontSize: 22, color: "#6b7280" }} />
                    </div>
                  </div>
                </div>
              </th>
              <th className="border-b border-gray-200 px-3 py-2 text-center">
                <div className="flex items-center justify-center">
                  Lost ({currency})
                  <div className="flex flex-col gap-y-1 ml-3">
                    <div
                      className="cursor-pointer"
                      onClick={() => LostSort("za")}
                    >
                      <ArrowDropUp sx={{ fontSize: 22, color: "#6b7280" }} />
                    </div>

                    <div
                      className="cursor-pointer -mt-2"
                      onClick={() => LostSort("az")}
                    >
                      <ArrowDropDown sx={{ fontSize: 22, color: "#6b7280" }} />
                    </div>
                  </div>
                </div>
              </th>
              <th className="border-b border-gray-200 px-3 py-2 text-center">
                <div className="flex items-center justify-center text-center">
                  Non Responsive ({currency})
                  <div className="flex flex-col gap-y-1 ml-3">
                    <div
                      className="cursor-pointer"
                      onClick={() => NonResponsiveSort("za")}
                    >
                      <ArrowDropUp sx={{ fontSize: 22, color: "#6b7280" }} />
                    </div>

                    <div
                      className="cursor-pointer -mt-2"
                      onClick={() => NonResponsiveSort("az")}
                    >
                      <ArrowDropDown sx={{ fontSize: 22, color: "#6b7280" }} />
                    </div>
                  </div>
                </div>
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200 bg-white">
            {groupedArray.length > 0 ? (
              groupedArray.map(
                ({ year, totalLeads, totalAmount, statusWise }) => (
                  <tr key={year}>
                    <td
                      className="border-b border-gray-200/40 px-3 py-1 text-left cursor-pointer"
                      onClick={() => handleTdClick(year)}                    >
                      {year}
                    </td>
                    <td
                      className="border-b border-gray-200/40 px-3 py-1 text-center"
                    >
                      {totalLeads}
                    </td>
                    {/* <td
                      className={`px-3 text-center py-2 ${statusWise["Won"]?.totalQuotedValue ? 'cursor-pointer' : ''}`}
                      onClick={statusWise["Won"]?.totalQuotedValue ? () => handleTdClick(year, "Won") : undefined}
                    >
                      {currency}  {statusWise["Won"]?.totalQuotedValue
                        ? USAComma(Number(statusWise["Won"]?.totalQuotedValue || 0).toFixed(0))
                        : "0"}
                    </td> */}
                    <td
                      className={`border-b border-gray-200/40 px-3 py-1 text-center ${Object.keys(statusWise).find(key => key.toLowerCase() === "won".toLowerCase()) &&
                        statusWise[
                          Object.keys(statusWise).find(key => key.toLowerCase() === "won".toLowerCase())
                        ]?.totalQuotedValue
                        ? "cursor-pointer"
                        : ""
                        }`}
                      onClick={() => {
                        const matchedKey = Object.keys(statusWise).find(
                          key => key.toLowerCase() === "won".toLowerCase()
                        );
                        if (matchedKey && statusWise[matchedKey]?.totalQuotedValue) {
                          handleTdClick(year, matchedKey);
                        }
                      }}
                    >
                    
                      {(() => {
                        const matchedKey = Object.keys(statusWise).find(
                          key => key.toLowerCase() === "won".toLowerCase()
                        );
                        return matchedKey && statusWise[matchedKey]?.totalQuotedValue
                          ? USAComma(Number(statusWise[matchedKey]?.totalQuotedValue || 0).toFixed(0))
                          : "0";
                      })()}
                    </td>

                    {/* <td
                      className="px-3 text-center py-2 cursor-pointer"
                      onClick={() => handleTdClick(year, "Won Recurring")}
                    > */}
                    {/* <td
                      className={`px-3 text-center py-2 ${statusWise["Won Recurring"]?.totalQuotedValue ? 'cursor-pointer' : ''}`}
                      onClick={statusWise["Won Recurring"]?.totalQuotedValue ? () => handleTdClick(year, "Won Recurring") : undefined}
                    >
                      {currency}   {statusWise["Won Recurring"]?.totalQuotedValue
                        ?
                        USAComma(Number(statusWise["Won Recurring"].totalQuotedValue || 0)?.toFixed(0))

                        : "0"}
                    </td> */}
                    <td
                      className={`border-b border-gray-200/40 px-3 py-1 text-center ${Object.keys(statusWise).find(
                        key => key.toLowerCase() === "won recurring".toLowerCase()
                      ) && statusWise[
                        Object.keys(statusWise).find(key => key.toLowerCase() === "won recurring".toLowerCase())
                      ]?.totalQuotedValue
                        ? "cursor-pointer"
                        : ""
                        }`}
                      onClick={() => {
                        const matchedKey = Object.keys(statusWise).find(
                          key => key.toLowerCase() === "won recurring".toLowerCase()
                        );
                        if (matchedKey && statusWise[matchedKey]?.totalQuotedValue) {
                          handleTdClick(year, matchedKey);
                        }
                      }}
                    >
                      
                      {(() => {
                        const matchedKey = Object.keys(statusWise).find(
                          key => key.toLowerCase() === "won recurring".toLowerCase()
                        );
                        return matchedKey && statusWise[matchedKey]?.totalQuotedValue
                          ? USAComma(Number(statusWise[matchedKey].totalQuotedValue || 0).toFixed(0))
                          : "0";
                      })()}
                    </td>

                    {/* <td
                      className={`px-3 text-center py-2 ${statusWise["Pending"]?.totalQuotedValue ? 'cursor-pointer' : ''}`}
                      onClick={statusWise["Pending"]?.totalQuotedValue ? () => handleTdClick(year, "Pending") : undefined}
                    >
                      {currency}   {
                        statusWise["Pending"]?.totalQuotedValue
                          ? USAComma(Number(statusWise["Pending"].totalQuotedValue || 0).toFixed(0))
                          : "0"
                      }
                    </td> */}
                    <td
                      className={`border-b border-gray-200/40 px-3 py-1 text-center ${Object.keys(statusWise).some(k => k.toLowerCase() === "pending" && statusWise[k]?.totalQuotedValue)
                        ? 'cursor-pointer'
                        : ''
                        }`}
                      onClick={
                        Object.keys(statusWise).some(k => k.toLowerCase() === "pending" && statusWise[k]?.totalQuotedValue)
                          ? () => handleTdClick(year, "Pending")
                          : undefined
                      }
                    >
                      
                      {USAComma(
                        Number(
                          Object.keys(statusWise)
                            .find(k => k.toLowerCase() === "pending")
                            ? statusWise[
                              Object.keys(statusWise).find(k => k.toLowerCase() === "pending")
                            ]?.totalQuotedValue
                            : 0
                        ).toFixed(0)
                      )}
                    </td>

                    {/* <td
                      className={`px-3 text-center py-2 ${statusWise["Lost"]?.totalQuotedValue ? 'cursor-pointer' : ''}`}
                      onClick={statusWise["Lost"]?.totalQuotedValue ? () => handleTdClick(year, "Lost") : undefined}
                    >
                      {currency}   {statusWise["Lost"]?.totalQuotedValue
                        ? USAComma(Number(statusWise["Lost"].totalQuotedValue || 0).toFixed(0))
                        : "0"}
                    </td> */}
                    <td
                      className={`border-b border-gray-200/40 px-3 py-1 text-center ${statusWise["Lost"]?.totalQuotedValue || statusWise["lost"]?.totalQuotedValue
                        ? 'cursor-pointer'
                        : ''
                        }`}
                      onClick={
                        statusWise["Lost"]?.totalQuotedValue || statusWise["lost"]?.totalQuotedValue
                          ? () => handleTdClick(year, "Lost")
                          : undefined
                      }
                    >
                     
                      {statusWise["Lost"]?.totalQuotedValue || statusWise["lost"]?.totalQuotedValue
                        ? USAComma(
                          Number(
                            statusWise["Lost"]?.totalQuotedValue || statusWise["lost"]?.totalQuotedValue || 0
                          ).toFixed(0)
                        )
                        : "0"}
                    </td>

                    <td
                      className={`border-b border-gray-200/40 px-3 py-1 text-center ${statusWise["Pending"]?.totalQuotedValue &&
                        year < new Date().getFullYear() - 1
                        ? "cursor-pointer"
                        : ""
                        }`}
                      onClick={
                        statusWise["Pending"]?.totalQuotedValue &&
                          year < new Date().getFullYear() - 1
                          ? () => handleTdClick(year, "Pending")
                          : undefined
                      }
                    >
                       {statusWise["Non Responsive"]?.totalQuotedValue
                        ?
                        USAComma(Number(statusWise["Non Responsive"].totalQuotedValue || 0).toFixed(0))

                        : "0"}
                    </td>
                  </tr>
                )
              )
            ) : (
              <tr className="text-center">
                <td colSpan="5" className="noDataAvailable">
                  No data available
                </td>
              </tr>
            )}

            <tr className="border-t border-gray-200 bg-gray-50 text-xs font-semibold">
              <td className="px-3 py-2 text-left">TOTAL:</td>
              <td className="px-3 py-2 text-center">{totalLeads}</td>
              <td className="px-3 py-2 text-center">
                
                {/* {
                  USAComma(
                    Number(
                      Object.values(statusWiseTotals["Won"] || {})
                        .reduce((sum, val) => sum + (Number(val) || 0), 0)
                    ).toFixed(0)
                  )
                } */}
                {
                  USAComma(
                    Number(
                      Object.entries(statusWiseTotals)
                        .filter(([key]) => key.toLowerCase() === "won".toLowerCase()) // case-insensitive match
                        .reduce((sum, [, val]) => sum + (Number(Object.values(val).reduce((s, v) => s + (Number(v) || 0), 0)) || 0), 0)
                    ).toFixed(0)
                  )
                }

              </td>
              <td className="px-3 py-2 text-center">
                
                {/* {
                  USAComma(
                    Number(
                      Object.values(statusWiseTotals["Won Recurring"] || {})
                        .reduce((sum, val) => sum + (Number(val) || 0), 0)
                    ).toFixed(0)
                  )
                } */}
                {
                  USAComma(
                    Number(
                      Object.entries(statusWiseTotals)
                        .filter(([key]) => key.toLowerCase() === "won recurring".toLowerCase()) // case-insensitive match
                        .reduce((sum, [, val]) => sum + (Number(Object.values(val).reduce((s, v) => s + (Number(v) || 0), 0)) || 0), 0)
                    ).toFixed(0)
                  )
                }


              </td>
              <td className="px-3 py-2 text-center">
               
                {
                  USAComma(
                    Number(
                      Object.entries(statusWiseTotals)
                        .filter(([key]) => key.toLowerCase() === "pending".toLowerCase()) // case-insensitive match
                        .reduce((sum, [, val]) => sum + (Number(Object.values(val).reduce((s, v) => s + (Number(v) || 0), 0)) || 0), 0)
                    ).toFixed(0)
                  )
                }

                {/* {
                  USAComma(
                    Number(
                      Object.values(statusWiseTotals["Pending"] || {})
                        .reduce((sum, val) => sum + (Number(val) || 0), 0)
                    ).toFixed(0)
                  )
                } */}
              </td>
              <td className="px-3 py-2 text-center">
                
                {/* {
                  USAComma(
                    Number(
                      Object.values(statusWiseTotals["Lost"] || {})
                        .reduce((sum, val) => sum + (Number(val) || 0), 0)
                    ).toFixed(0)
                  )
                } */}
                {
                  USAComma(
                    Number(
                      Object.entries(statusWiseTotals)
                        .filter(([key]) => key.toLowerCase() === "lost".toLowerCase()) // case-insensitive match
                        .reduce((sum, [, val]) => sum + (Number(Object.values(val).reduce((s, v) => s + (Number(v) || 0), 0)) || 0), 0)
                    ).toFixed(0)
                  )
                }

              </td>
              <td className="px-3 py-2 text-center">
                
                {
                  USAComma(
                    Number(
                      Object.values(statusWiseTotals["Non Responsive"] || {})
                        .reduce((sum, val) => sum + (Number(val) || 0), 0)
                    ).toFixed(0)
                  )
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HistoricaltableL1;
